import api from '@/lib/api/axios'
import type { Role, Permission } from '@/types/entities'

export interface ListParams {
    page?: number
    limit?: number
    search?: string
}

export interface CreateRoleRequest {
    name: string
    description?: string
    permissionIds?: number[]
}

export interface UpdateRoleRequest {
    name?: string
    description?: string
    permissionIds?: number[]
}

export interface RoleResponse {
    success: boolean
    data: Role[]
    total?: number
    page?: number
    limit?: number
}

export interface SingleRoleResponse {
    success: boolean
    data: Role
}

export interface PermissionsResponse {
    success: boolean
    data: Permission[]
}

export const rolesApi = {
    // Get all roles
    async getRoles(params?: ListParams): Promise<RoleResponse> {
        const searchParams = new URLSearchParams()
        if (params?.page) searchParams.append('page', params.page.toString())
        if (params?.limit) searchParams.append('limit', params.limit.toString())
        if (params?.search) searchParams.append('search', params.search)

        const response = await api.get(`/api/roles?${searchParams.toString()}`)
        return response.data
    },

    // Get a single role by ID
    async getRole(id: number): Promise<SingleRoleResponse> {
        const response = await api.get(`/api/roles/${id}`)
        return response.data
    },

    // Create a new role
    async createRole(data: CreateRoleRequest): Promise<SingleRoleResponse> {
        const response = await api.post('/api/roles', data)
        return response.data
    },

    // Update an existing role
    async updateRole(id: number, data: UpdateRoleRequest): Promise<SingleRoleResponse> {
        const response = await api.put(`/api/roles/${id}`, data)
        return response.data
    },

    // Delete a role
    async deleteRole(id: number): Promise<void> {
        await api.delete(`/api/roles/${id}`)
    },

    // Get all available permissions
    async getAllPermissions(): Promise<PermissionsResponse> {
        const response = await api.get('/api/roles/permissions/all')
        return response.data
    },
}
